import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "vab-nav"
};
const _hoisted_2 = {
  class: "left-panel"
};
const _hoisted_3 = {
  class: "right-panel"
};
const _hoisted_4 = {
  class: "nav-icon-fullscreen"
};
const _hoisted_5 = {
  class: "nav-icon-refresh"
};
const _hoisted_6 = {
  style: {
    "padding-left": "8px"
  }
};
import { useRoutesStore } from '@/store/modules/routes';
import { translate } from '@/i18n';
import { isExternal } from '@/utils/validate';
import { openFirstMenu } from '@/config';
import { getTenant } from '~/src/utils';

import { useRouter } from 'vue-router';
import { useFullscreen } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import { nextTick } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    layout: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    const router = useRouter();
    const tenant = getTenant();
    const routesStore = useRoutesStore();
    const {
      isFullscreen
    } = useFullscreen();
    const {
      getTab: tab,
      getTabMenu: tabMenu,
      getRoutes: routes
    } = storeToRefs(routesStore);
    const handleTabClick = () => {
      console.log(111);
      nextTick(() => {
        if (isExternal(tabMenu.value.path)) {
          window.open(tabMenu.value.path);
          setTimeout(() => {
            router.push('/');
          }, 1000);
        } else if (openFirstMenu) router.push(tabMenu.value.redirect || tabMenu.value);
      });
    };
    return (_ctx, _cache) => {
      const _component_vab_fold = _resolveComponent("vab-fold");
      const _component_vab_icon = _resolveComponent("vab-icon");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_vab_breadcrumb = _resolveComponent("vab-breadcrumb");
      const _component_el_col = _resolveComponent("el-col");
      const _component_vab_full_screen = _resolveComponent("vab-full-screen");
      const _component_vab_refresh = _resolveComponent("vab-refresh");
      const _component_vab_helper = _resolveComponent("vab-helper");
      const _component_vab_avatar = _resolveComponent("vab-avatar");
      const _component_el_row = _resolveComponent("el-row");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
        gutter: 15
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          lg: 12,
          md: 12,
          sm: 12,
          xl: 12,
          xs: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [__props.layout !== 'float' ? (_openBlock(), _createBlock(_component_vab_fold, {
            key: 0
          })) : _createCommentVNode("", true), __props.layout === 'comprehensive' ? (_openBlock(), _createBlock(_component_el_tabs, {
            key: 1,
            modelValue: _unref(tab).data,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(tab).data = $event),
            "tab-position": "top",
            onTabClick: handleTabClick
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routes), (item, index) => {
              return _openBlock(), _createBlock(_component_el_tab_pane, {
                key: index + item.name,
                name: item.name
              }, {
                label: _withCtx(() => [item.meta.icon ? (_openBlock(), _createBlock(_component_vab_icon, {
                  key: 0,
                  icon: item.meta.icon,
                  "is-custom-svg": item.meta.isCustomSvg,
                  style: {
                    "min-width": "16px"
                  }
                }, null, 8, ["icon", "is-custom-svg"])) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(_unref(translate)(item.meta.title)), 1)]),
                _: 2
              }, 1032, ["name"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])) : (_openBlock(), _createBlock(_component_vab_breadcrumb, {
            key: 2,
            class: "hidden-xs-only"
          }))])]),
          _: 1
        }), _createVNode(_component_el_col, {
          lg: 12,
          md: 12,
          sm: 12,
          xl: 12,
          xs: 20
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, [_createVNode(_component_vab_full_screen)]), _createElementVNode("span", _hoisted_5, [_createVNode(_component_vab_refresh)]), _createVNode(_component_vab_helper), _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(tenant).name), 1), _createVNode(_component_vab_avatar)])]),
          _: 1
        })]),
        _: 1
      })], 512)), [[_vShow, !_unref(isFullscreen)]]);
    };
  }
});